module.exports = __webpack_public_path__ + "static/media/germany-flag.0e0c4906.svg";